import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import { GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid'
import { Delete, Sync } from 'mdi-material-ui'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'


const OrderToolbar = props => {
  const { numSelected, selected, setReload } = props

  const UpdateOrder = async () => {
    selected.forEach(async item => {
      try {
        await apiService.put('/proc/update', item);
        toast.success('수정 되었습니다');
        setReload(reload => reload + 1);
      } catch (error) {
        console.error(error);
      }
    });
  }

  const DeleteOrder = async () => {
    selected.forEach(async item => {
      try {
        await apiService.delete(`/proc/${item.orderid}/${item.cartid}`);
        toast.success('주문이 삭제되었습니다.');
        setReload(reload => reload + 1);
      } catch (error) {
        console.error(error);
      }
    });
  }

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Update'>
              <IconButton sx={{ color: '#006A4E' }} onClick={UpdateOrder} >
                <Sync />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton sx={{ color: '#f44336' }} onClick={DeleteOrder} >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}
      </Box>
    </Box>
  )
}

export default OrderToolbar
